import { z } from 'zod';
import { authResponseSchema } from '../auth/auth.schemas.js';
import { aliasRegex } from '../common/alias.js';
import { companyCreateSchema } from '../companies/company.schemas.js';
import { siteCreateSchema } from '../sites/site.schemas.js';

export const setupStatusSchema = z.object({
  requiresSetup: z.boolean(),
});

export const setupStep1Schema = z.object({
  alias: z
    .string()
    .min(3, { message: 'L’alias doit contenir au moins 3 caractères' })
    .max(64, { message: 'L’alias ne doit pas dépasser 64 caractères' })
    .regex(aliasRegex, { message: 'Caractères autorisés : a-z 0-9 . _ -' }),
  password: z
    .string()
    .min(12, { message: 'Le mot de passe doit contenir au moins 12 caractères' })
    .max(200, { message: 'Mot de passe trop long' }),
  firstName: z
    .string()
    .min(1, { message: 'Le prénom est obligatoire' })
    .max(100, { message: 'Le prénom ne doit pas dépasser 100 caractères' }),
  lastName: z
    .string()
    .min(1, { message: 'Le nom est obligatoire' })
    .max(100, { message: 'Le nom ne doit pas dépasser 100 caractères' }),
  email: z
    .union([
      z.literal(''),
      z
        .string()
        .email({ message: 'Adresse e-mail invalide' })
        .max(255, { message: 'L’e-mail ne doit pas dépasser 255 caractères' }),
    ])
    .transform((v) => (v === '' ? undefined : v)),
  phone: z.string().max(50, { message: 'Le numéro est trop long' }).optional(),
});

export const setupStep2Schema = companyCreateSchema;

export const setupStep3Schema = z.object({
  sites: z.array(siteCreateSchema).min(1, { message: 'Au moins un site est requis' }).max(50),
  preferredSiteIndex: z.number().int().nonnegative(),
});

export const setupInitializeSchema = z.object({
  admin: setupStep1Schema,
  company: setupStep2Schema,
  step3: setupStep3Schema,
});

export type SetupStatus = z.infer<typeof setupStatusSchema>;
export type SetupStep1Input = z.infer<typeof setupStep1Schema>;
export type SetupStep2Input = z.infer<typeof setupStep2Schema>;
export type SetupStep3Input = z.infer<typeof setupStep3Schema>;
export type SetupInitializeInput = z.infer<typeof setupInitializeSchema>;

export const setupInitializeResponseSchema = authResponseSchema;
export type SetupInitializeResponse = z.infer<typeof setupInitializeResponseSchema>;
